/**
 * Permission helpers for the AI model configuration center (Issue #187).
 *
 * Mirrors the backend `PERMISSION_CATALOG` for `ai_models:*`, `ai_credentials:*`,
 * and `ai_audits:*` strings declared in
 * `apps/api/src/auth/services/module-catalog.ts`. Frontend nav gating cannot
 * drift from backend `@RequirePermission(...)` decorators.
 */
import { hasPermission } from './crmPermissions';

export const AI_MODEL_CENTER_PERMISSIONS = {
  MODELS_READ: 'ai_models:read',
  MODELS_WRITE: 'ai_models:write',
  MODELS_SYNC: 'ai_models:sync',
  CREDENTIALS_READ: 'ai_credentials:read',
  CREDENTIALS_WRITE: 'ai_credentials:write',
  AUDITS_READ: 'ai_audits:read',
  AUDITS_REVIEW: 'ai_audits:review',
} as const;

export function canSeeAiModelCenterMenu(permissions: readonly string[]): boolean {
  return hasPermission(permissions, AI_MODEL_CENTER_PERMISSIONS.MODELS_READ);
}
